import { IFaireDirectProps } from "@faire/deprecated-retailer-visitor-shared/app/_lib/faire-direct-visitor/faire-direct/faireDirectTypes";
import { useFaireDirectBrandInfoForVisitor } from "@faire/deprecated-retailer-visitor-shared/app/_lib/faire-direct-visitor/faire-direct/useFaireDirectBrandInfoForVisitor";
import { AppSignUpModalVariant } from "@faire/deprecated-retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { useFaireDirectBrand } from "@faire/deprecated-retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useSettingFaireDirectSignupForVisitorXP } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFaireDirectCreditForVisitor";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

interface IProps extends IFaireDirectProps {
  modalVariant: AppSignUpModalVariant;
  align?: "left" | "center";
}

export const Title: React.FC<IProps> = ({
  modalVariant,
  align,
  brandTokenOrBrandAlias,
}) => {
  return (
    <Typography variant="displaySSerifRegular" align={align ?? "center"}>
      <TitleText
        modalVariant={modalVariant}
        brandTokenOrBrandAlias={brandTokenOrBrandAlias}
      />
    </Typography>
  );
};

const TitleText: React.FC<
  { modalVariant: AppSignUpModalVariant } & IFaireDirectProps
> = ({ modalVariant, brandTokenOrBrandAlias }) => {
  const { faireDirectBrand } = useFaireDirectBrand();
  const isFaireDirectCreditForVisitorPhase2 =
    useSettingFaireDirectSignupForVisitorXP();
  const { faireDirectBrandName: faireDirectBrandNameFromInfoByBrand } =
    useFaireDirectBrandInfoForVisitor(brandTokenOrBrandAlias);
  const brandName = isFaireDirectCreditForVisitorPhase2
    ? faireDirectBrandNameFromInfoByBrand
    : faireDirectBrand?.name;

  if (modalVariant === AppSignUpModalVariant.FAIRE_DIRECT) {
    return brandName ? (
      <StrictLocalMsg
        id="Z3UErO"
        defaultMessage="Buy {brandCompanyName}, risk‑free"
        description={{
          text: "Title on signup modal encouraging users to sign up in order to buy products from a certain brand. brandCompanyName is the name of the brand that the user is viewing.",
          img: "https://cdn.faire.com/fastly/a8758a8ee20614d4e3c9db463b46dabd4c6cea0912426dd428534b42489be49a.png",
        }}
        values={{
          brandCompanyName: brandName,
        }}
      />
    ) : (
      <StrictLocalMsg
        id="TdMQvp"
        defaultMessage="Buy from this brand, risk‑free"
        description={{
          text: "Title on signup modal encouraging users to sign up in order to buy products from the brand currently being viewed.",
          img: "https://cdn.faire.com/fastly/3ea07572521c4f7618469060b324b8874b56c8d2fe9e00489ff5f6b00abc5100.png",
        }}
      />
    );
  } else if (modalVariant === AppSignUpModalVariant.NAV_ACCOUNT) {
    return (
      <StrictLocalMsg
        id="bkzBNB"
        defaultMessage="Access your account"
        description={{
          text: "Our main sign up modal title, sign up to access your account",
          img: "https://cdn.faire.com/fastly/565c86808ca58bab1604bbf7d08db3a99789ab83e3b3bbc069c77c8dbfadb071.png",
        }}
      />
    );
  } else if (modalVariant === AppSignUpModalVariant.NAV_CART) {
    return (
      <StrictLocalMsg
        id="9RoWJ3"
        defaultMessage="Access your cart"
        description={{
          text: "Our main sign up modal title, sign up to access your cart",
          img: "https://cdn.faire.com/fastly/a0750166709121cd81fd63af4c5a12c9563ecae27444c13f51c30f9f8d2bf6bd.png",
        }}
      />
    );
  } else {
    return (
      <StrictLocalMsg
        id="1U70mU"
        defaultMessage="Unlock wholesale pricing"
        description={{
          text: "Our main sign up modal title",
          img: "https://cdn.faire.com/fastly/d4039290caa4b4b1195bac7d196759088d8040225fc98a0c9aa75c3d88a750d5.png",
        }}
      />
    );
  }
};
